import React from 'react'

import createGlobalHook from './createGlobalHook'
import states from './states'
import actions from './actions'

const useGlobal = createGlobalHook(React, states, actions)

export default useGlobal
